import React from "react";
import { TableCell, TableRow } from "@mui/material";

// import PermissionCheck from "../../../Component/PermissionCheck";
import dele from "../../../assets/DigitalMarketing/image/delete.svg";

import schedule from "../../../assets/DigitalMarketing/image/Schedule.svg";
import AlertDialog from "../../../Component/DigitalMarketing/deleteConfirmation";
import { useDeleteCustomerBloodAppointmentMutation } from "../../../Service/CustomerBloodAppointment";
import useDeleteBox from "../../../hooks/digitalMarketing/useDeleteBox";

interface props {
  customer_list: any;
  getComparator: any;
  order: any;
  orderBy: string;
  handleClick: any;
  handleChange: any;
  stableSort: any;
  refetch: any;
}
function TableList({
  customer_list,
  getComparator,
  order,
  orderBy,
  handleClick,
  handleChange,
  stableSort,
  refetch,
}: props) {
  const [deleteAppointment] = useDeleteCustomerBloodAppointmentMutation();

  const { open, message, openDelete, deleteId } = useDeleteBox();

  let statuss = [
    {
      label: "Active",
      value: 1,
      icon: (
        <span style={{ backgroundColor: "green" }} className="blue me-2"></span>
      ),
    },
    {
      label: "Inactive",
      value: 2,
      icon: (
        <span style={{ backgroundColor: "red" }} className="blue me-2"></span>
      ),
    },
  ];

  const Delete = async (bool) => {
    if (bool) {
      await deleteAppointment(deleteId);
      refetch();
    }
    openDelete(
      "Are you sure you want to delete this appointment?",
      false,
      null
    );
  };
  return (
    <>
      <>
        <AlertDialog open={open} message={message} deleteBranches={Delete} />
      </>
      {customer_list?.map((a, i) => {
        return (
          <TableRow
            hover
            className="cursur"
            role="checkbox"
            tabIndex={-1}
            key={i}
          >
            <TableCell align="center">{a.customerName}</TableCell>
            <TableCell align="left">{a.phone1}</TableCell>
            <TableCell align="left">
              <span className={a.status === 1 ? "green" : "pink"}></span>&nbsp;{" "}
              {a.status === 1 ? "Scheduled" : "Rescheduled"}
            </TableCell>{" "}
            <TableCell className="center" align="left">
              {a.area}
            </TableCell>
            <TableCell align="left">
              <div
                className={
                  a.status === 1 ? "green-bg" : a.status === 2 ? "red-bg" : ""
                }
              >
                {a.bloodTestDate}
              </div>
            </TableCell>
            <TableCell align="left">{a.bloodTestTime}</TableCell>
            <TableCell align="left">
              <img
                src={schedule}
                alt=""
                className="delete-icon cursur action-icon me-2"
                onClick={(event) => handleClick(event, a.bloodCollectionId)}
              />

              <img
                src={dele}
                alt=""
                onClick={() =>
                  openDelete(
                    "Are you sure you want to delete this appointment?",
                    true,
                    a.bloodCollectionId
                  )
                }
                className="delete-icon cursur action-icon"
              />
            </TableCell>
          </TableRow>
        );
      })}
    </>
  );
}
export default React.memo(TableList);
